import {Component} from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {ICellRendererParams} from "ag-grid-community";
import {MatButton} from "@angular/material/button";
import {ICharityBalance} from "../../../interfaces/charity/ICharityBalance";

@Component({
  selector: 'app-charity-payout-actions',
  standalone: true,
  templateUrl: './charity-payout-actions.component.html',
  imports: [
    MatButton
  ],
  styleUrls: ['./charity-payout-actions.component.css']
})
export class CharityPayoutActionsComponent implements ICellRendererAngularComp {

  public rowData!: ICharityBalance;
  private onMakePayoutClick?: (charityId: string) => void;

  agInit(params: ICellRendererParams & {
    onMakePayoutClick?: (charityId: string) => void
  }): void {
    this.rowData = params.data;
    this.onMakePayoutClick = params.onMakePayoutClick;
  }

  refresh(_params: ICellRendererParams): boolean {
    return false;
  }

  handleMakePayoutClick(): void {
    if (this.onMakePayoutClick && this.rowData.CharityId) {
      this.onMakePayoutClick(this.rowData.CharityId);
    }
  }

  shouldShowButton(): boolean {
    return this.rowData && this.rowData.AmountOwed > 0;
  }
}
